import { render, staticRenderFns } from "./OrganizationChartComponent.vue?vue&type=template&id=545aa460&scoped=true"
import script from "./OrganizationChartComponent.vue?vue&type=script&lang=js"
export * from "./OrganizationChartComponent.vue?vue&type=script&lang=js"
import style0 from "./OrganizationChartComponent.vue?vue&type=style&index=0&id=545aa460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545aa460",
  null
  
)

export default component.exports